export const getTelegramBotLink = () => ({
  type: "@saga/GET_TELEGRAM_BOT_LINK",
});
